/**
 * MainLayout Component (Option 2: Two-Column with Sidebar)
 *
 * Wraps form steps with a two-column layout:
 * - Left: Form content
 * - Right: Summary sidebar
 */

import { SummaryPanel } from '../common'
import './MainLayout.css'

function MainLayout({ children }) {
  return (
    <div className="main-layout">
      <div className="form-column">
        {children}
      </div>
      <SummaryPanel />
    </div>
  )
}

export default MainLayout
